import axios from 'axios';
import { triggerShowLoader, triggerHideLoader } from '../LoadingContext'; // Import trigger functions

// Create a new Axios instance
const apiClient = axios.create({
  // baseURL will be set by Axios using global defaults (axios.defaults.baseURL)
  // which is configured in index.js
  timeout: 3000, // 3 second timeout for all requests
});

// Request Interceptor
apiClient.interceptors.request.use(
  async config => {
    // The baseURL is expected to be resolved by Axios using the global defaults
    // set in index.js (axios.defaults.baseURL).
    // We no longer need to manually try to set it here.
    
    // console.log(`[apiClient Request] Interceptor - Config URL: ${config.url}, Current axios.defaults.baseURL: ${axios.defaults.baseURL}`);

    const token = localStorage.getItem('jwtToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    triggerShowLoader();
    return config;
  },
  error => {
    console.error('[apiClient] Request setup error:', error);
    triggerHideLoader(); // Ensure loader is hidden on request setup error
    return Promise.reject(error);
  }
);

// Response Interceptor for Loading State
apiClient.interceptors.response.use(
  response => {
    // Any status code within 2xx range triggers this
    // Decrement count after successful response
    triggerHideLoader();
    return response;
  }, 
  error => {
    // Any status code outside 2xx range triggers this
    // Decrement count after error (including timeout)
    console.warn('[apiClient] Request failed or timed out:', error.message);
    triggerHideLoader();
    
    // Optional: Handle specific errors like 401 Unauthorized (e.g., redirect to login)
    // if (error.response && error.response.status === 401) {
    //   // Handle unauthorized access - maybe dispatch logout action
    //   console.error("Unauthorized access - potential token expiry");
    //   // window.location.href = '/login'; // Example redirect
    // }
    
    return Promise.reject(error);
  }
);

export default apiClient; 